// lib/designerHost.ts · v12.10.25 (#2103 Change template only on a Support visit) · 2026-10-30 · VoiceSpectrum AI
// lib/designerHost.ts · v12.10.3 (BDR-016 step 1) · 2026-10-03 · VoiceSpectrum AI
// T2 is a HOST of the shared workflow designer (Source/src/shared-designer). It hands the designer T2's own api client and
// toast, the tenant mode, and T2's Phone & Activation section - the designer itself knows no URL, token or database.
// Imported once from main.tsx, before anything renders.
import { configureDesignerHost } from '@shared-designer/src/host';
import { api } from './api';
import { toast } from './toast';
import { getCachedMe } from './useAccess';
import { PhoneActivationSection, usePhoneHandlesLabel } from '../components/aiagent/PhoneActivationSection';

configureDesignerHost({
  api,
  toast,
  mode: 'tenant',
  slots: { PhoneActivationSection, usePhoneHandlesLabel },
  // v12.10.25 (#2103, Tushar 10/29): Change template is not shown to anyone in the practice (Owner included) - only on a Support visit.
  canChangeTemplate: () => !!getCachedMe()?.isSupport,
});
